import { fetchApi } from 'shared/functions';
import { ESGUpdateYear } from '../../modules/ESG/types';

export const peergroupComparisonService = (id: string, params?: ESGUpdateYear) =>
  fetchApi(`/esg/api/${id}/dashboard/peergroup-comparison/`, { query: params }).then((response) =>
    response.json(),
  );
